import React from "react";

interface ButtonProps {
  onClick?: () => void;
  label: string;
}

export function Button({ onClick, label }: ButtonProps) {
  return (
    <button type="button" className="nes-btn is-primary" onClick={onClick}>
      {label}
    </button>
  );
}

interface TextInputProps {
  text: string;
  setText: (newText: string) => void;
  placeholder?: string;
  id?: string;
}

export function TextInput(props: TextInputProps) {
  const { text, setText, id, placeholder = "" } = props;
  return (
    <input
      id={id}
      type="text"
      className="nes-input is-dark"
      placeholder={placeholder}
      value={text}
      onChange={e => setText(e.target.value)}
    />
  );
}
